'use client';

type EventParams = Record<string, string | number | boolean | null | undefined>;

type GtagFn = (command: 'event', eventName: string, params?: EventParams) => void;

declare global {
  interface Window {
    gtag?: GtagFn;
  }
}

export function trackEvent(eventName: string, params: EventParams = {}) {
  if (typeof window === 'undefined') {
    return;
  }

  if (typeof window.gtag !== 'function') {
    return;
  }

  window.gtag('event', eventName, params);
}
